<template>
    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12">
        <span class="timestamp-hour">{{ transaction_data.log_time }}</span>
        <span class="message-bg">
            <template
                    v-if="transaction_data.action_metadata && transaction_data.action_metadata.action_name && transaction_data.action_metadata.action_name !== ''">
                <span>{{transaction_data.action_metadata.action_name}}</span><br>

                <template
                        v-if="transaction_data.action_metadata.entity_name && transaction_data.action_metadata.entity_name !== ''">
                    <span>Entity: {{transaction_data.action_metadata.entity_name}}</span><br>
                </template>

                <template
                        v-if="transaction_data.action_metadata.domain_name && transaction_data.action_metadata.domain_name !== ''">
                    <span>Domain: {{transaction_data.action_metadata.domain_name}}</span><br>
                </template>
            </template>
            <template v-else>
                <span class="target">Type: </span>
                <span class="message">{{ transaction_data.action_type }}</span><br>
            </template>

            <span>Status:
                <span :class="transaction_data.status_class">
                    <template v-if="isStatus(transaction_status_codes.LOG_STATUS_IN_PROGRESS, transaction_data.status_code)">
                        <fa icon="spinner" spin/>
                    </template>
                    {{ transaction_data.status }}
                </span>
            </span>
            <br>
            <span><em>by: {{ transaction_data.username }}</em></span>
            <br>
            <h5>Transactions</h5>
            <template v-if="has_data === false">
              Loading details, please wait ...
            </template>
            <template v-else>
              <b-table
                  striped
                  hover
                  :items="transactions"
                  :fields="table_fields"
                  sort-by="id"
                  :sort-desc="true"
                  :show-empty="true"
                  empty-text="There are no transactions available."
              >
                  <template v-slot:cell(transaction_id)="data">
                      {{ data.item.id }}
                  </template>
                  <template v-slot:cell(transaction_name)="data">
                      <template v-if="data.item.has_fetch_error">error reading transaction</template>
                      <template v-else>
                          {{data.item.transaction_metadata.transaction_name}}
                      </template>
                  </template>
                  <template v-slot:cell(transaction_details)="data">
                      <template v-if="data.item.has_fetch_error">{{data.item.fetch_error_text}}</template>
                      <template v-else>
                          <template v-if="data.item.transaction_metadata.entity_name">Entity: {{data.item.transaction_metadata.entity_name}}<br></template>
                          <template v-if="data.item.transaction_metadata.domain_name">Domain: {{data.item.transaction_metadata.domain_name}}<br></template>
                      </template>
                  </template>
                  <template v-slot:cell(status)="data">
                      {{ data.item.status }}
                  </template>
                  <template v-slot:cell(show_details)="row">
                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                      {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                    </b-button>
                  </template>
                  <template v-slot:row-details="row">
                    <b-card>
                      <b-row>
                        <b-col sm="3" class="text-sm-right">Step</b-col>
                        <b-col>Status</b-col>
                        <b-col>Duration</b-col>
                        <b-col>Details</b-col>
                      </b-row>
                      <b-row v-for="transaction_step in row.item.transaction_metadata.transaction_steps">
                        <b-col sm="3" class="text-sm-right"><b>{{ transaction_step.name }}</b></b-col>
                        <b-col>
                          <template v-if="transaction_step.needed === 0">
                            not required
                          </template>
                          <template v-else>
                            <template v-if="transaction_step.status === 1">
                              success
                            </template>
                            <template v-else-if="transaction_step.status === 0">
                              fail
                            </template>
                            <template v-else>
                              <template v-if="transaction_step.start === -1">
                                not started
                              </template>
                              <template v-else>
                                <template v-if="transaction_step.progress > 0 && transaction_step.progress < 100">
                                  {{ transaction_step.progress }}%
                                </template>
                                <template v-else>
                                  in progress
                                </template>
                              </template>
                            </template>
                          </template>
                        </b-col>
                        <b-col>
                          <template v-if="transaction_step.needed === 1">
                            <template v-if="transaction_step.status === 1">
                              {{ transaction_step.end - transaction_step.start }}s
                            </template>
                          </template>
                        </b-col>
                        <b-col>{{ transaction_step.data }}</b-col>
                      </b-row>
                    </b-card>
                  </template>
              </b-table>
            </template>
        </span>
        <action-log-details-ccs-modal></action-log-details-ccs-modal>
    </div>
</template>
<script>

import {mapState, mapGetters} from "vuex";
import CcsModal from "@/components/CcsModal.vue";

	export default {
		components: {
      ActionLogDetailsCcsModal: CcsModal,
    },
    mounted()
    {
      this.loadData();
    },
		props: {
			transaction_data: {
				type: Object,
				default: () => {
					return {
						transaction_name: "Unknown transaction name",
					}
				}
			},
		},
		data()
		{
			let my_table_fields = [
				{
					key: "transaction_id",
					label: "Id",
					sortable: false
				},
				{
					key: "transaction_name",
					label: "Transaction name",
					sortable: false
				},
				{
					key: "transaction_details",
					label: "Details name",
					sortable: false
				},
				{
					key: "status",
					label: "Status",
					sortable: false
				},
				{
					key: "show_details",
					label: "",
					sortable: false
				},
			];

			return {
				table_fields: my_table_fields,
        transactions: [],
        has_data: false,
        reload_details_timer: null,
      };
		},
		computed: {
      ...mapState("platformUpdates", ["transaction_status_codes"]),
      ...mapGetters({
        isStatus: "platformUpdates/isStatus",
      }),
    },
		watch: {},
		methods: {
      load_transaction_details() {

        if(this.transaction_data.has_details === 0)
        {
          this.$modal.show("action-log-details-ccs-modal-dialog", {
            type: "error",
            title: "No data",
            text: "No additional data is available for this action log",
            buttons: [
              {
                title: "Close",
                default: true // Will be triggered by default if 'Enter' pressed.
              }
            ]
          });
          return;
        }

        this.$store.dispatch("platformUpdates/GetActionLogDetails", this.transaction_data.log_id).then(
            (success_data) => {
              if(success_data.status === 'OK')
              {
                for (let [transaction_id, transaction_details] of Object.entries(success_data.data.action_details.data)) {
                  let found = 0;
                  transaction_id = parseInt(transaction_id);
                  for(let i = 0; i < this.transactions.length; i++)
                  {
                    if(this.transactions[i].transaction_id === transaction_id)
                    {
                      found = 1;

                      this.$set(this.transactions[i], 'status', transaction_details.status);
                      this.$set(this.transactions[i], 'status_code', transaction_details.status_code);
                      this.$set(this.transactions[i].transaction_metadata, 'transaction_steps', transaction_details.transaction_metadata.transaction_steps);
                      break;
                    }
                  }

                  if(found === 0)
                  {
                    let new_transaction = JSON.parse(JSON.stringify(transaction_details));
                    new_transaction.transaction_id = transaction_id;
                    new_transaction._showDetails = false;
                    this.transactions.push(new_transaction)
                  }

                  if(
                      this.isStatus(this.transaction_status_codes.LOG_STATUS_ON_ERROR, success_data.data.status_code) === false &&
                      this.isStatus(this.transaction_status_codes.LOG_STATUS_FINISHED, success_data.data.status_code) === false
                  )
                  {
                    this.reload_details_timer = setTimeout(this.load_transaction_details, 1000);
                  }

                  this.has_data = true;
                }
              }
              else
              {
              }
            },
            (error_data) => {
              this.$modal.show("action-log-details-ccs-modal-dialog", {
                type: "error",
                title: "Error processing action log data",
                text: error_data,
                buttons: [
                  {
                    title: "Close",
                    default: true // Will be triggered by default if 'Enter' pressed.
                  }
                ]
              });
              this.reload_details_timer = setTimeout(this.load_transaction_details, 1000);
              return;
            }
        );
      },
      loadData() {
        this.load_transaction_details();
      }
    },
    beforeDestroy() {
		  if(this.reload_details_timer !== null)
      {
        clearTimeout(this.reload_details_timer);
        this.reload_details_timer = null;
      }
    },
	};
</script>
